// removed by extract-text-webpack-plugin
module.exports = {"AreaInput":"_2iUwqqUbx9mm6mDFvDKpEm","TextInput":"_19bQQYF6UMoiMi_Hir3z6T","EditorWrapper":"AGbBA1E-fgJhlTJXW58O_","Editor":"_2793gUP4_R4cKyeHdXci4f","Toolbar":"_3z501Tm72Fbo-m8J3lQfOQ","SmileyModalContainer":"_3c9UnQs2saWQpfIDTLD_rn","Emoji":"_3R2LZXXFdvo0xg5nMZmtAx"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Markdown/style.css
// module id = 764
// module chunks = 0